module.exports = __webpack_public_path__ + "img/arrowDown.fff3aaaf.svg";